<template>
  <div :class="classes">
    <div class="progress-bar__title">{{ title }}</div>
    <div class="progress-bar__track">
      <div class="progress-bar__track__value" :style="valueStyles"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4ProgressBar",
  props: {
    title: {
      type: String
    },
    variant: {
      type: String,
      default() {
        return "primary";
      }
    },
    value: {
      type: Number,
      default() {
        return 0;
      }
    }
  },
  computed: {
    classes() {
      let classes = ["progress-bar"];
      classes.push("progress-bar--" + this.variant);
      return classes;
    },
    valueStyles() {
      return {
        width: this.value + "%"
      };
    }
  }
};
</script>
